module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/3/2-a6108357cf4d239dadc629d243994423.jpg";